import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'

import { PATH } from '../../constants/global'
import { useAPI } from '..'
import { useState } from 'react'
import { APIError } from '../types'
import { getAPIErrorMessage } from '../../utils/functions'

export default function ({
   toolId,
   currentLocationId,
}: UseWarehousesParams): UseWarehouses {
   const request = useAPI()
   const [errorMessage, setErrorMessage] = useState<string | null>(null)

   const { data, isLoading, isRefetching, isError, isSuccess } = useQuery(
      'warehouses',
      getItemWarehousesFromAPI,
      {
         onError: (error: APIError) => {
            const msg = getAPIErrorMessage(error)
            setErrorMessage(msg)
         },
      }
   )

   async function getItemWarehousesFromAPI(): Promise<
      AxiosResponse<WarehousesResponse>
   > {
      const toolIdParam = toolId ? `?toolId=${Number(toolId)}` : ''
      const currentLocationIdParam =
         toolId && currentLocationId
            ? `&currentLocationId=${Number(currentLocationId)}`
            : currentLocationId
            ? `?currentLocationId=${Number(currentLocationId)}`
            : ''
      return await request.get(
         `${PATH.LOCATIONS.ITEM_WAREHOUSES}${toolIdParam}${currentLocationIdParam}`
      )
   }

   return {
      list: data?.data ?? [],
      isLoading: isLoading || isRefetching,
      error: errorMessage,
      isError,
      isSuccess,
   }
}
